import * as React from 'react';
import { Theme, css } from '@emotion/react';
import { Typography } from 'bento';

export type SidebarNavHeaderProps = React.HTMLAttributes<HTMLDivElement>;

const sidebarNavHeader = ({ spacing }: Theme) => css`
  padding: ${spacing(2)}px ${spacing(1)}px ${spacing(0.5)}px;
`;

/**
 * @deprecated Deprecated — no pantry replacement available yet.
 * Migration: No direct pantry mapping — please reach out to the Design Systems team on Slack (e.g., #pantry-design-system) for assistance with a pantry replacement.
 */
export const SidebarNavHeader: React.FunctionComponent<
  React.PropsWithChildren<SidebarNavHeaderProps>
> = ({ children }) => {
  return (
    <Typography css={sidebarNavHeader} variant="overline" color="subtle">
      {children}
    </Typography>
  );
};
